import TemplateView from '../../../../../../js/TemplateView'
import messageResource from '../../../../../../js/messageResource'
import UserNameFormat from '../../../../../../js/util/UserNameFormat'
import GroupType from '../../../../../../js/enums/GroupType'
import UserSelectionInfoListItem from './UserSelectionInfoListItem'
import {escapeHtmlSymbols} from '../../../../../../js/atUtils'

export default class UsersSelectionDetailedInfoContent extends TemplateView {
    constructor() {
        super()

        this.state = {
            titleKey: '',
            groups: [],
            users: [],
            groupType: null,
        }

        this.onStateChanged(() => this._update())
    }

    templateHtml() {
        return `<div class='usersSelectionDetailedInfoContent'>
                    <div class='title'/>
                    <ul class='groupsList itemsList'/>
                    <div class='usersTitle'><%=usersTitle%></div>
                    <ul class='usersList itemsList'/>
                </div>`
    }

    messageKeys() {
        return {
            usersTitle: 'icalendar.page.table.users.detailedInfo.userList',
        }
    }

    afterRender() {
        this.$title = this.find('.title')
        this.$departmentsList = this.find('.groupsList')
        this.$usersList = this.find('.usersList')
        this.$usersTitle = this.find('.usersTitle')
    }

    _update() {
        this.$departmentsList.empty()
        this.$usersList.empty()

        const hasUserGroups = this.state.groups.length > 0

        this.$title.text(messageResource.getMessage(this.state.titleKey, [this.getTitle()]))

        this.$usersTitle.toggle(hasUserGroups && this.state.users.length > 0)

        if (hasUserGroups) {
            this.state.groups.forEach(userGroup => {
                new UserSelectionInfoListItem({
                    text: escapeHtmlSymbols(userGroup.name),
                }).init(this.$departmentsList)
            })
        }

        this.state.users.forEach(user => {
            new UserSelectionInfoListItem({
                text: escapeHtmlSymbols(UserNameFormat.formatLFM(user.firstName, user.lastName, user.middleInitial)),
            }).init(this.$usersList)
        })
    }

    getTitle() {
        return this.state.groups.length > 0
               ? this.getUserGroupsPluralText(this.state.groupType)
               : messageResource.getMessage('common.users')
    }

    getUserGroupsPluralText(groupType) {
        return groupType === GroupType.TIME_ZONE_GROUP
               ? messageResource.getMessage('common.time_zone_groups')
               : messageResource.getMessage('common.user_groups')
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/usersDetailedInfo/UsersSelectionDetailedInfoContent.js